import styled from '@emotion/styled';
import { flexContainer, spacer } from '@tokens';
import type { StackProps } from './StackTypes';

type LayoutProps = Pick<
  StackProps,
  'spacing' | 'customSpacing' | 'direction' | 'preset'
>;

const stackLayout = ({
  spacing,
  customSpacing,
  direction,
  preset,
}: LayoutProps) => {
  const gap = spacer[spacing] || customSpacing;
  return `  
  ${flexContainer(preset, {
    ...(gap && { gap }),
    ...(direction && { direction }),
  })};`;
};

/**
 * Stack is a helper for vertical and horizontal layouts, using a Flex container.
 *
 * {@link https://storybook.hotjar.com/?path=/docs/components-stack--stack Code documentation}
 *
 * @example
 * <Stack>
 *   <div>Item</div>
 * </Stack>
 */

export const Stack = styled.div<StackProps>`
  ${stackLayout}
  ${({ shouldWrap }) => shouldWrap && `flex-wrap: wrap;`}
`;
